export type AppStorePlatform = 'ios' | 'android' | 'unknown';

/** Best-effort client hint for store links (not a security boundary). */
export function inferAppStorePlatform(): AppStorePlatform {
  if (typeof navigator === 'undefined') return 'unknown';
  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
  if (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1) return 'ios';
  if (/Android/i.test(ua)) return 'android';
  return 'unknown';
}
